import { useContext } from "react";
import { IframeMessagingContext, iframeMessagingContext } from "./iframeMessagingContext";

export const useIframeMessaging = (): IframeMessagingContext  => {
  return useContext(iframeMessagingContext);
}